import React from 'react';
import { OperationsList } from '../OperationsList';
import { PropertiesList } from '../PropertiesList';
import { GuidesMarkdownDisplayList } from '../GuideMarkdownList';
import { MainEntity } from '../MainEntity';
import { EventsList } from '../EventsList/EventsList';
import { ClientEventsList } from './ClientEventsList';
import { ApiSectionView } from '../index';

interface ApiSectionMembersProps {
  prefix: string;
  childrenKeys: string[];
  node: any;
  depth: number;
}

export const ApiSectionMembers = React.memo<ApiSectionMembersProps>(
  ({ prefix, childrenKeys, node, depth }) => {
    return (
      <React.Fragment key={`${prefix}__${depth}`}>
        <GuidesMarkdownDisplayList prefix={prefix} node={node} />
        <MainEntity prefix={prefix} node={node} />
        <PropertiesList prefix={prefix} node={node} />
        <OperationsList prefix={prefix} node={node} />
        <ClientEventsList prefix={prefix} node={node} />
        <EventsList prefix={prefix} node={node} />
        {renderSubTreesData()}
      </React.Fragment>
    );

    function renderSubTreesData() {
      const subSections = [];
      childrenKeys.forEach((key) => {
        subSections.push(
          <ApiSectionView
            depth={depth + 1}
            prefix={prefix}
            key={`${key}__${node.data.urlFormat}`}
            node={node[key]}
            shouldOpenSubCategory={childrenKeys.length === 1}
          />,
        );
      });
      return subSections;
    }
  },
);
